export const createArray = (num: number): number[] => {
  return Array(num).fill(0);
};
